const getUserInterrations = async (bot_id, start, end, period) => {
  const serverDomain = process.env.REACT_APP_SERVER;

  try {
    if (!bot_id) {
      return { error: true, msg: "bot_id is required.", data: null };
    }

    // Construct query parameters
    const params = new URLSearchParams();
    params.append("bot_id", bot_id);

    if (period !== null && period !== undefined) {
      params.append("period", period);
    } else {
      if (start) params.append("start", start.toISOString());
      if (end) params.append("end", end.toISOString());
    }

    const url = `${serverDomain}/analysis/user-interactions?${params.toString()}`;

    const response = await fetch(url);

    if (!response.ok) {
      const errorBody = await response.json();
      return {
        error: true,
        msg: errorBody.message || "Failed to fetch data",
        data: null,
      };
    }

    const data = await response.json();
    return {
      error: false,
      msg: "Fetched interaction data successfully.",
      data,
    };
  } catch (err) {
    console.error("Error in getUserInterrations:", err);
    return {
      error: true,
      msg: "Something went wrong while fetching interaction data.",
      data: null,
    };
  }
};

export default getUserInterrations;
